export var eventHandlerAttr = function (_logger) { return ({
    shouldPreprocessNode: function (node) {
        return (node.attribs &&
            Object.keys(node.attribs).filter(function (x) {
                return x.startsWith('on');
            }).length > 0);
    },
    preprocessNode: function (node) {
        for (var key in node.attribs) {
            if (key.startsWith('on')) {
                try {
                    // @ts-ignore
                    var _attrValue = Function(node.attribs[key]);
                }
                catch (e) {
                    _logger.warn("Mailformed js function in ' " +
                        key +
                        " ' Uniform has replaced it. Please check the static html and fix the function.");
                    var value = "console.error('Warning: function has been replaced by Uniform')";
                    node.attribs[key] = value;
                }
            }
        }
    },
}); };
//# sourceMappingURL=eventHandlerAttr.js.map